import axios from "axios";

export default {
  state: {
    projectInformationAllList: [], //灵工数据-用于发票新增
    financialSettlementList: [],//结算数据
  },
  mutations: {
    setProjectInformationAllList: (state, data) => {
      state.projectInformationAllList = data
    },
    setFinancialSettlementGroupDetailList: (state, data) => {
      state.financialSettlementList = data
    },
  },
  actions: {
    findProjectInformationAllList(context) {
      // let params = {
      //   is_group: 0,//不属于项目组
      // };
      // axios.post('home/findProjectInformationAllList', params).then(res => {
      //   if (res.data.flag === 'success') {
      //     context.commit('setProjectInformationAllList', res.data.message)
      //   }
      // }, (() => {
      // }))
    },
    findFinancialSettlementGroupDetailList(context) {
      // let params = {
      //   'is_my_data': 2,//数据与账号客户有关
      //   'business_type': '灵活用工服务收入',
      // };
      // axios.post("home/findFinancialSettlementGroupDetailList", params)
      //   .then(
      //     res => {
      //       if (res.data.flag === "success") {
      //         context.commit('setFinancialSettlementGroupDetailList', res.data.message)
      //       }
      //     },
      //     err => {
      //     }
      //   ).finally(() => {
      // });
    },

  }
}





// WEBPACK FOOTER //
// ./src/views/lgSystem/lg_store/lgInfo.js